import { FieldWrapper } from "@/forms/field-wrapper";
import { useFormContext } from "react-hook-form";
import { DatePicker } from "@/components/ui/date-picker";
import { DebugData } from "@/service/debug";

export const DateField = ({
  field,
  disabled = false,
  shouldRenderLabel = true,
  onChange = () => {},
  labelClassName = undefined,
}: FormField) => {
  const { control } = useFormContext();

  return (
    <FieldWrapper
      field={field}
      control={control}
      disabled={disabled}
      shouldRenderLabel={shouldRenderLabel}
      labelClassName={labelClassName}
      renderComponent={(formField) => (
        <div className={"relative"}>
          <DatePicker
            onChange={(date) => {
              formField.onChange(date);
            }}
            initialDate={field.value}
          />
          <input
            {...formField}
            type="hidden"
            name={field.name}
            id={field.name}
            value={formField.value ?? field.value}
          />
        </div>
      )}
    />
  );
};
